import { getAjaxData } from "../functions/ajax-get-data";
import { loaderInstanse } from "../functions/scripts/loaderInstanse";

document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.js-infinite-tags');
    if (!container) return;

    const termId = container.getAttribute('data-term');
    const { ajax_url, nonce } = window.ajax_params || {};
    
    let isLoading = false;
    let hasMore = true;

    // Скрытый маяк без стилей для отладки
    const sentinel = document.createElement('div');
    sentinel.style.height = '1px'; 
    container.after(sentinel);

    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !isLoading && hasMore) {
            loadNextPage();
        }
    }, { 
        rootMargin: '0px 0px 100px 0px' // Начинаем загрузку за 400px до появления маяка
    });

    observer.observe(sentinel);

    function loadNextPage() {
        isLoading = true;
        loaderInstanse(container, true);

        // Собираем все ID со страницы для исключения
        const currentIds = Array.from(document.querySelectorAll('.blog-list__item[data-id]'))
                                .map(item => item.getAttribute('data-id'))
                                .filter(Boolean);

        getAjaxData(ajax_url, 'get_tags', {
            nonce: nonce,
            term_id: termId,
            exclude: currentIds.join(',')
        }, (res) => {
            if (res.success && res.data.html.trim() !== "") {
                container.insertAdjacentHTML('beforeend', res.data.html);

                // Анимация каскадного появления
                const newItems = container.querySelectorAll('.blog-list__item.ajax-loaded:not(.is-visible)');
                newItems.forEach((item, index) => {
                    setTimeout(() => item.classList.add('is-visible'), index * 100); 
                });

                hasMore = res.data.more;
            } else {
                hasMore = false;
                observer.unobserve(sentinel);
                sentinel.remove();
            }

            setTimeout(() => {
                loaderInstanse(container, false);
                isLoading = false;
            }, 300);
        });
    }
});